import { render } from "./PhotoProcessingManager.vue?vue&type=template&id=3d20471b&ts=true"
import script from "./PhotoProcessingManager.vue?vue&type=script&lang=ts"
export * from "./PhotoProcessingManager.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__